import { render, staticRenderFns } from "./ArticleListView.vue?vue&type=template&id=e1a3b7f4&scoped=true&"
import script from "./ArticleListView.vue?vue&type=script&lang=js&"
export * from "./ArticleListView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListView.vue?vue&type=style&index=0&id=e1a3b7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a3b7f4",
  null
  
)

export default component.exports